import React from "react";
import "assets/styles/home/PlatformHome.scss";
import "font-awesome/css/font-awesome.min.css";
import logo from "assets/img/logo-white.svg";

const PlatformHome = () => {
  const features = [
    { title: "Ecommerce", icon: "fa-shopping-cart" },
    { title: "API flexible y plugins optimizados", icon: "fa-cogs" },
    { title: "Pagos recurrentes", icon: "fa-refresh" },
    { title: "Terminales inteligentes de última generación", icon: "fa-mobile" },
    { title: "Pagos presenciales", icon: "fa-credit-card" },
    { title: "Meses sin intereses", icon: "fa-percent" }
  ];

  return (
    <div className={'platformWrapper'}>
      <div className={'platform'}>
        <div className={'platformLeft'}>
          <img src={logo} alt="etomin" className={'platformLogo'} />
        </div>
        <div className={'platformRight'}>
          <div className={'platformHeader'}>
            <h2 className={'platformTitle'}>
              <span className={'platformTitleOrange'}>Una plataforma,</span>
              <br />
              <span className={'platformTitleWhite'}>TODAS LAS POSIBILIDADES</span>
            </h2>
          </div>
          <div className={'platformGrid'}>
            {features.map((feature, index) => (
              <div key={index} className={'platformCard'}>
                <div className={'platformCardContent'}>
                  <span className={'platformCardTitle'}>{feature.title}</span>
                  <i className={`fa ${feature.icon} platformCardIcon`}></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformHome;
